let toastTimeout = null;

export function showToast(message, durationMs = 2500) {
    const toast = document.getElementById('toast');
    if (!toast) {
        return;
    }

    toast.textContent = message;
    toast.classList.remove('is-hidden');
    toast.classList.add('toast-visible');

    if (toastTimeout) {
        clearTimeout(toastTimeout);
    }

    toastTimeout = setTimeout(() => {
        toast.classList.remove('toast-visible');
        toast.classList.add('is-hidden');
    }, durationMs);
}
